export default "__VITE_ASSET__CDrOCmFV__"